import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

Vue.use(Vuex);

export const COMPANY_CONFIG_MODULE = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default COMPANY_CONFIG_MODULE;
